<script>
import Layout from "../../../layouts/main.vue"
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      AproveOvertime: [],
      currentUser: {},
      page: 1,
      limit: 20,
      tot_pages: 0,
      SearchMode: false,
      searchModel: "",
      date: "",
      month: "",
      year: "",
      isHrManager: false,
      isHead: false,
      config: {},
      // state: state,
    };
  },
  methods: {
    search(page) {
      this.SearchMode = true;
      this.tot_pages = 0;
      if (this.searchSalaryItems == "") {
        this.get(this.page);
        return;
      }
      this.http
        .post("hr-attendance/overtime-approval/search", {
          search: this.searchModel,
          limit: this.limit,
          page: page,
          month: this.month,
          year: this.year,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.AproveOvertime = res.data;
        });
    },

    getAproveOvertime(page) {
      this.http.post("hr-attendance/hr-approve-overtime/pagination",
      {
          limit: this.limit,
          page: page,
        }
      ).then((res) => {
        this.page = page;
        this.tot_pages = Math.ceil(res.tot / this.limit);
        this.AproveOvertime = res.data;
      });
    },

    approve(app, isHead, isHrManager) {
      let head_approve;
      let hr_manager_approve;
      if (isHead && !isHrManager) {
        head_approve = true
        hr_manager_approve = app.hr_manager_approve
      } else if (isHead && isHrManager) {
        head_approve = true
        hr_manager_approve = true
      } else {
        head_approve = app.head_approve
        hr_manager_approve = true
      }
      Swal.fire({
        title: this.$t("popups.approve"),
        text: this.$t("popups.approve_msg"),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("popups.yes"),
        cancelButtonText: this.$t("popups.cancel")
      }).then((result) => {
        if (result.isConfirmed) {
          this.http
            .put("hr-attendance", app.id, {
              hr_manager_approve: hr_manager_approve,
              head_approve: head_approve
            })
            .then(() => {
              Swal.fire({
                title: this.$t("popups.approved"),
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
              });
              this.get(this.page);
            });
        }
      });
    },

    getConfig() {
      this.http.get("emps/config").then((res) => {
          this.config = res.data.reduce((acc, item) => {
          acc[item.name_en] = item.value;
          return acc;
          }, {});        
      });
    },

    get(page) {
      this.http
        .post("hr-attendance/overtime-approval", {
          limit: this.limit,
          page: page,
          month: this.month,
          year: this.year,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.AproveOvertime = res.data;
          console.log('AproveOvertime', this.AproveOvertime)
        });
    },
    updateMonth() {
      const date = new Date(this.date);
      this.month = date.getMonth() + 1;
      this.year = date.getFullYear();
      this.searchModel? this.search(this.page) : this.get(this.page);
    }
  },
  created() {
    this.currentUser = JSON.parse(localStorage.currentUser);
    // this.isHrManager = ['hm'].includes(this.currentUser?.role?.code);
    this.isHrManager = this.currentUser?.user_roles?.some(
      ur => ur.role?.code === "hm"
    );
    this.isHead = this.currentUser?.user_roles?.some(
      ur => ur.role?.code === "admin"
    );


    // this.isHead = ['admin'].includes(this.currentUser?.role?.code);

    const date = new Date();
    this.month = date.getMonth() + 1;
    this.year = date.getFullYear();

    this.$nextTick(() => {

      this.getConfig();        
      this.get(1);
    })
    // this.getAproveOvertime(1);
  },
  watch: {
    date() {
      this.updateMonth();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('hr_aprove_overtime.title')"
    />
    <div class="row mb-3">
      <div class="col-6">
        <div class="search-box chat-search-box" style="width: 250px">
          <div class="position-relative">
            <input
              :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
              @input="search(page)"
              type="search"
              class="form-control fa-lg text-light"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-3"></div>
      <div class="col-3">
        <div class="row">
          <!-- <label class="inline" for="toJobTitle">{{ $t("payroll.master.month") }}</label> -->
          <input type="month" class="form-control" v-model="date"/>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
        <thead>
          <tr class="text-light text-center" style="background-color: #2a3042 !important">
            <th scope="col">#</th>
            <th scope="col">{{ $t("hr_employees.employee") }}</th>
            <!-- <th scope="col">{{ $t("hr_employees.basic_salary") }}</th> -->
            <th scope="col">{{ $t("hr_employees.actual_sart") }}</th>
            <th scope="col">{{ $t("hr_employees.actual_end") }}</th>
            <th scope="col">{{ $t("hr_employees.check_in") }}</th>
            <th scope="col">{{ $t("hr_employees.check_out") }}</th>
            <th scope="col">{{ $t("hr_employees.over_time_hours") }}</th>
            <th scope="col">{{ $t("hr_employees.date") }}</th>
            <th scope="col">{{ $t("hr_awards.approvement") }}</th>
            <th scope="col">{{ $t("hr_employees.operations") }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(emp, empIndex) in AproveOvertime" :key="empIndex">
            <!-- Parent Row: Employee Info -->
            <tr class="text-center fw-bold" style="background-color: #efefef !important">
              <td>{{ empIndex + 1 }}</td>
              <td>{{ emp.name }}</td>
              <!-- <td>{{ parseFloat(emp.basic_salary).toLocaleString() }}</td> -->
              <td colspan="8" class="text-muted">
                <span v-if="emp.employee_overtime_list.length === 0">
                  {{ $t("hr_employees.no_overtime") }}
                </span>
                <span v-else>
                  {{ $t("hr_employees.overtime_list") }}
                </span>
              </td>
            </tr>

            <!-- Child Rows: Overtime Entries -->
            <tr
              v-for="(ot, otIndex) in emp.employee_overtime_list"
              :key="`${emp.id}-${otIndex}`"
              class="text-center"
            >
              <td></td>
              <td colspan="1"></td>
              <td>{{ ot.work_start_time || '-' }}</td>
              <td>{{ ot.work_end_time || '-' }}</td>
              <td>{{ ot.check_in }}</td>
              <td>{{ ot.check_out }}</td>
              <td>
                {{ ot.over_time_hours }}
                <span class="text-muted small">hrs</span>
              </td>
              <td>{{ ot.date?.split("T")[0] }}</td>
              <td>
                <div>{{ isHrManager }} / {{ ot.hr_manager_approve }} {{ ot.head_approve }}</div>
                <span
                  :class="{
                    'badge-soft-success': isHrManager? ot?.hr_manager_approve : ot.head_approve,
                    'badge-soft-danger': isHrManager? !ot?.hr_manager_approve : !ot.head_approve
                  }"
                  class="badge badge-pill font-size-11"
                >
                  {{ isHrManager && ot?.hr_manager_approve ||  isHead && ot.head_approve? $t('hr_awards.approved') : $t('hr_awards.not_approved') }}
                </span>
              </td>
              <td class="d-flex justify-content-center">
                <a
                  v-if="isHrManager? !ot.hr_manager_approve && ['Hr Manager', 'Hr Manager and general Manager'].includes(config['Overtime Approvement Manager']) : !ot.head_approve && config['Overtime Approvement Manager'] === 'Hr Manager and general Manager'"
                  class="btn btn-primary mx-1"
                  @click="approve(ot, isHead, isHrManager)"
                  href="javascript:void(0);"
                >
                  {{ $t("popups.approve") }}
                </a>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <!-- end  table -->
    </div>

    <div>
      <!--   Apps  paginate     -->
      <ul
        class="pagination pagination-rounded justify-content-center mb-2"
      >
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel? search(page - 1) : get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel? search(p) : get(p)"
            >{{ p }}</a
          >
        </li>

        <li
          class="page-item"
          :class="{ disabled: page == tot_pages }"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel? search(page + 1) : get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
